// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileJpgOutlinedSvg from "@ant-design/icons-svg/es/asn/FileJpgOutlined";
import AntdIcon from '../components/AntdIcon';

var FileJpgOutlined = function FileJpgOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileJpgOutlinedSvg
  }));
};

FileJpgOutlined.displayName = 'FileJpgOutlined';
export default React.forwardRef(FileJpgOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileJpgOutlined.js
// module id = 1115
// module chunks = 0